export const validateBackBoxRangeInputValues = (
  rangeType: string,
  minRange: string,
  maxRange: string,
  currency: string,
) => {
  const minPriceOrAmount = minRange ? Number(minRange) : undefined
  const maxPriceOrAmount = maxRange ? Number(maxRange) : undefined

  if (
    typeof minPriceOrAmount !== 'number' ||
    typeof maxPriceOrAmount !== 'number'
  )
    return false

  if (rangeType === 'percentage') {
    return (
      minPriceOrAmount >= 0 &&
      maxPriceOrAmount >= 1 &&
      maxPriceOrAmount > minPriceOrAmount
    )
  }

  if (rangeType === 'amount') {
    return (
      minPriceOrAmount >= 0 &&
      maxPriceOrAmount >= 0 &&
      maxPriceOrAmount > minPriceOrAmount &&
      currency !== ''
    )
  }

  return false
}
